<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: 'min(28rem, 94vw)'}"
  [header]="'shared.qr.dialog.title' | translate"
  (onHide)="hide()"
>
  <div *ngIf="data" class="qr-dialog">
    <div class="qr-dialog__preview">
      <div class="qr-dialog__card">
        <div *ngIf="qrImageUrl" class="qr-dialog__code">
          <img
            [src]="qrImageUrl"
            [alt]="data.title"
            class="qr-dialog__image"
          />
          <div class="qr-dialog__logo" [style.width.%]="qrLogoWidth * 100"
               [style.height.%]="qrLogoHeight * 100" [style.padding.%]="qrLogoPadding * 100">
            <img [src]="qrLogoUrl" alt="WTG">
          </div>
        </div>
        <div class="qr-dialog__card-title">{{ data.title }}</div>
      </div>
    </div>

    <div class="qr-dialog__content">
      <p *ngIf="subtitleText" class="qr-dialog__subtitle">{{ subtitleText }}</p>
      <p class="qr-dialog__description">{{ 'shared.qr.dialog.description' | translate }}</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="qr-dialog__footer">
      <button
        pButton
        type="button"
        class="p-button-text p-button-rounded"
        icon="pi pi-times"
        (click)="hide()"
        [label]="'common.close' | translate"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-text p-button-rounded"
        icon="pi pi-image"
        (click)="shareQr()"
        [label]="'shared.qr.dialog.share_qr' | translate"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-text p-button-rounded"
        icon="pi pi-share-alt"
        (click)="shareLink()"
        [label]="'shared.qr.dialog.share_link' | translate"
      ></button>
    </div>
  </ng-template>
</p-dialog>
